import { Button, tokens } from '@fluentui/react-components'
import { ArrowLeftFilled, ShieldErrorFilled } from '@fluentui/react-icons'
import React from 'react'
import { rootUseStyles } from '../../taskpane/fluent-style'
import { useTabStore } from '../../providers/TabProvider';
import { useResultStore } from '../../providers/ResultProvider';
import { TabKey } from '..';
import { parseAIResult } from '../../utils/parseAIResult';
import { AlertChip } from '../../components/Alert/AlertChip';
import { alertConfigType } from '../../components/Alert/alert.config';
import TableContent from '../../components/TableContent';

interface ReportPhishingButtonProps {
    currentTab: TabKey;
    disableIcon?: boolean;
}

export default function ReportPhishingButton({ currentTab, disableIcon }: ReportPhishingButtonProps) {
    const [open, setOpen] = React.useState(false);
    const { reportSent } = useResultStore();

    return (
        <>
            {open && <ConfirmationModal currentTab={currentTab} setOpen={setOpen} />}
            <Button
                disabled={reportSent}
                className={rootUseStyles().buttonWarning}
                icon={disableIcon ? undefined : <ShieldErrorFilled />}
                onClick={() => {
                    // setActiveTab("report-phishing");
                    setOpen(true);
                }}
            >
                Report as Phishing
            </Button>
        </>
    )
}

const scanColumns = [
    {
        name: "Scan",
        key: "scan",
    },
    {
        name: "Status",
        key: "status",
    }
];

function ConfirmationModal({ currentTab, setOpen }: {
    currentTab: TabKey;
    setOpen: (open: boolean) => void;
}) {
    const { setActiveTab } = useTabStore();
    const emailData = useTabStore((s) => s.emailData);
    const insightData = useResultStore((s) => s.insightData);
    const data = insightData;
    const deepScanData = useResultStore((s) => s.deepScanData);

    const parsedAIResult = parseAIResult(data?.ai_email_analysis_result);

    const items = [
        {
            name: "Ai Insight",
            value: (
                <AlertChip
                    type={parsedAIResult?.overall_ai_insight_result || "info" as alertConfigType}
                    label={parsedAIResult?.overall_ai_insight_result || "Clean"}
                />
            ),
        },
        // {
        //     name: "deep scan",
        //     value: (

        //         <></>
        //     ),
        // },
    ];

    return (
        <div
            style={{
                height: "95%",
                overflow: "hidden",
                backgroundColor: tokens.colorNeutralBackground1,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: "0px 0px 40px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: "10px",
            }}
        >
            <div
                style={{
                    padding: "10px 5px 0px 5px",
                }}
            >
                <Button
                    size="small"
                    appearance="subtle"
                    onClick={() => {
                        setActiveTab(currentTab);
                        setOpen(false);
                    }}
                    icon={<ArrowLeftFilled />}
                >
                    Cancel
                </Button>
            </div>
            <div style={{
                height: "100%",
                overflow: "auto",
                padding: "0px 15px 0px 15px",
            }}>
                {/* description */}
                <div>
                    <h2
                        style={{
                            fontSize: "16px",
                            fontWeight: 600,
                            margin: "10px 0",
                        }}
                    >
                        Review Before Reporting
                    </h2>
                    <p
                        style={{
                            fontSize: "12px",
                            fontWeight: 400,
                        }}
                    >
                        This report will trigger an alert in AQUILA and be shared with the security team for further assessment and action.
                    </p>
                </div>
                {/* content */}
                <div
                    style={{
                        border: `1px solid ${tokens.colorNeutralStroke1}`,
                        borderRadius: "6px",
                        overflow: "hidden",
                        padding: "8px",
                    }}
                >
                    <div style={{
                        marginBottom: "10px",
                    }}>
                        <p
                            style={{
                                fontSize: "10px",
                                fontWeight: 400,
                                margin: "5px 0px"
                            }}
                        >
                            Email Subject <br />
                            <strong style={{ fontWeight: 600 }}>{emailData.subject}</strong>
                        </p>
                        <p
                            style={{
                                fontSize: "10px",
                                fontWeight: 400,
                                margin: "5px 0px"

                            }}
                        >
                            Sender <br />
                            <strong style={{ fontWeight: 600 }}>{emailData.sender}</strong>
                        </p>
                    </div>
                    <p
                        style={{
                            fontSize: "10px",
                            fontWeight: 400,
                            margin: "5px 0px"

                        }}
                    >
                        Results
                    </p>
                    <TableContent columns={scanColumns} rows={items} />
                </div>

            </div>
            <div
                style={{
                    padding: "0px 15px",
                }}
            >
                <Button
                    className={rootUseStyles().buttonWarning}
                    icon={<ShieldErrorFilled />}
                    onClick={() => {
                        setActiveTab("report-phishing");
                    }}
                >
                    Proceed to Report
                </Button>
            </div>
        </div>
    );
}

